module.exports = __webpack_public_path__ + "img/logo_boton_payU.f1206cc0.png";